import React from 'react'

import { Document } from '@react-pdf/renderer'
import RatesPage, { IRatesPage } from './Pages/RatesPage'
import PlansPage, { IPlansPage } from './Pages/PlansPage'
import DetailsPage from './Pages/DetailsPage'
import CoverPage from './Pages/CoverPage'
import CensusPage from './Pages/CensusPage'
import FundingBreakdownPage from './Pages/FundingBreakdownPage'

type IQuoteProposalPDFProps = {
  ratesPageProps: IRatesPage
  plans: IPlansPage['plan'][]
}

const QuoteProposalPDF = ({
  ratesPageProps,
  plans
}: IQuoteProposalPDFProps) => {
  return (
    <Document>
      <CoverPage
        quoteId={ratesPageProps.quoteId}
        effectiveDate={ratesPageProps.quoteDetails.effectiveDate}
        groupName={ratesPageProps.groupName}
      />
      <RatesPage {...ratesPageProps} />
      {plans.map((plan) => (
        <PlansPage key={plan.planId} plan={plan} />
      ))}
      <DetailsPage pepmPayable={ratesPageProps.quoteDetails.pepmPayable} />
      <FundingBreakdownPage rates={ratesPageProps.rates} />
      <CensusPage census={ratesPageProps.census} />
    </Document>
  )
}

export default QuoteProposalPDF
